import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { useState } from "react";
import { toast } from "react-toastify";
import ViewLogo from "../../assets/view-icon.svg";
import EditIcon from "../../assets/common/editBoxIcon.png";
import {
  addDocumentTemplate,
  editDocumentTemplate,
  getDocument,
  getDocumentEditor,
  getWorkFlowTemplatesById,
  saveDocumentEditor,
} from "api";

import { Loader } from "@progress/kendo-react-indicators";
import { FileDocumentTypes } from "components/Enums/FileDocumentTypes.ts";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import { BiLoaderCircle } from "react-icons/bi";
import { CrossIcon } from "components/tabs/TabTitle";
import fileIcon from "components/common/fileIcon";
import { FaUpload, FaInfoCircle } from "react-icons/fa";
import SaveIcon from "assets/SaveIcon.png";
import { Tooltip } from "@progress/kendo-react-tooltip";

import DocumentViewer from "components/common/DocumentViewer";
import { excelExt, wordExt } from "components/common/DocumentViewer/fileUtils";

const AddEditDocTemplate = (props) => {
  const [loading, setLoading] = useState(false);
  const [isDocLoading, setIsDocLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [workFlowData, setWorkFlowData] = useState();
  const [showDocument, setShowDocument] = useState(false);
  const [documentViewerData, setDocumentViewerData] = useState();
  const [templateName, setTemplateName] = useState(
    props?.isEdit && props.component !== "WORK_FLOW"
      ? { filename: props?.isEdit?.templateName }
      : "",
  );
  const fileInputRef = React.useRef(null); // Ref for the hidden file input
  const { uploadForm } = useUploadForm();
  const handleFilePick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger click on hidden file input
    }
  };

  const getDocumentData = async (id) => {
    const { data } = await getDocument(id);
    setDocumentViewerData(data?.data?.documentFile || data.data);
  };

  const showDocumentFile = async (id) => {
    setShowDocument(true);
  };

  const handleFileChange = async (e) => {
    try {
      setFileLoading(true);
      let data = onFileUpload(e);
      console.log(props?.matterId);
      if (data) {
        const parameters = {
          documentType: FileDocumentTypes.CaseFile,
          matterId: props?.matterId,
        };
        const dataChoosen = await uploadForm(
          data,
          e.target.files[0],
          parameters,
        );
        setTemplateName(dataChoosen?.data?.data);
        setFileLoading(false);
      }
    } catch (error) {
    } finally {
      setFileLoading(false);
    }
  };
  const [name, setName] = useState(props?.isEdit ? props?.isEdit.name : "");
  const [details, setDetails] = useState(
    props?.isEdit ? props?.isEdit.details : "",
  );
  const [processingFileName, setProcessingFileName] = useState(
    props?.isEdit ? props?.isEdit.processingFileName : "",
  );
  const [resultFileName, setFileName] = useState(
    props?.isEdit ? props?.isEdit.resultFileName : "",
  );

  const getWorkFlowData = async (id) => {
    setLoading(true); // Set loading to true when the fetch starts
    try {
      const data = await getWorkFlowTemplatesById(id);
      setName(data?.data?.data?.name);
      setDetails(data?.data?.data?.details);
      setProcessingFileName(data?.data?.data?.processingFileName);
      setFileName(data?.data?.data?.resultFileName);
      setWorkFlowData(data?.data?.data);
      if (data?.data?.data?.templateName) {
        setTemplateName({ filename: data?.data?.data?.templateName });
      }
      await getDocumentData(data?.data?.data?.documentId);
    } catch (error) {
    } finally {
      setLoading(false); // Set loading to false when the fetch is done
    }
  };

  const getDocumentEditorData = async (id, type) => {
    try {
      // setLoader(true);
      const { data } = await getDocumentEditor(id, props.matterId);
      let editUrl = data?.data?.editURL;
      if (type === "Local") {
        let ext = "";
        if (documentViewerData?.filename) {
          ext = documentViewerData.filename.split(".").pop().toLowerCase();
        }
        if (["xls", "xlsx"].includes(ext)) {
          editUrl = `ms-excel:ofe|u|${editUrl}`;
        } else {
          editUrl = `ms-word:ofe|u|${editUrl}`;
        }
      }
      window.open(editUrl, "_blank");
      await getDocumentData(id);
    } catch (error) {
    } finally {
      // setLoader(false);
    }
  };

  const saveDocuemntEdit = async (id) => {
    try {
      await saveDocumentEditor(id, props?.matterId);
      await getDocumentData(id);
      toast.success("Document Saved");
    } catch (error) {
      toast.error("Error occured while editing");
    } finally {
    }
  };

  React.useEffect(() => {
    if (props.component === "WORK_FLOW") {
      getWorkFlowData(props.isEdit);
    }
  }, []);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const folderData = {
        fileId: templateName?.fileID,
        processingFileName,
        resultFileName,
        active: true,
        name,
        details,
        documentTemplateId: props.isEdit
          ? props.isEdit.documentTemplateId || props.isEdit
          : undefined,
      };

      if (props.isEdit) {
        await editDocumentTemplate(
          props.isEdit.documentTemplateId || props.isEdit,
          {
            ...props.isEdit,
            ...folderData,
          },
        );
        props.updateTemplates(folderData);
      } else {
        await addDocumentTemplate(folderData);
        props.updateTemplates();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const DocumentItem = ({ doc, setFiles }) => (
    <div className={`d-flex align-items-center justify-content-between w-100 `}>
      <div className="d-flex align-items-center">
        <div>{fileIcon(doc?.filename)}</div>
        <div>
          <span className="document-name-container ps-2 fs-sm ">
            {doc?.filename && doc?.filename?.length <= 20
              ? doc?.filename
              : doc?.filename.substring(
                  0,
                  20 -
                    (doc?.filename.includes(".")
                      ? doc?.filename.split(".").pop()?.length + 1
                      : 0),
                ) +
                (doc?.filename.includes(".")
                  ? "." + doc?.filename.split(".").pop()
                  : "")}
          </span>
        </div>
      </div>
      <div>
        <CrossIcon onClick={(e) => setFiles(e)} />
      </div>
    </div>
  );

  return (
    <Dialog
      title={`${props?.isEdit ? "Edit" : "Add"} Document Template`}
      onClose={props.cancelEdit}
      width={550}
      className="p-3"
    >
      <form onSubmit={handleSubmit}>
        <div className={`p-2 m-4 mt-0 ms-5 me-5`} style={{ height: 350 }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%", // Ensure loader takes the full height of the dialog
              }}
            >
              <Loader size="large" type="infinite-spinner" />{" "}
              {/* Centered loader */}
            </div>
          ) : (
            <div>
              <div className="mt-3">
                <Label className="label mb-1 w-100">Name&nbsp;</Label>
                <Input
                  className="px-3 pt-1"
                  style={{
                    width: "320px",
                    height: "32px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  value={name}
                  required
                  placeholder={"Enter Name"}
                  name="name"
                  type="text"
                />
              </div>{" "}
              <div className="mt-3">
                <Label className="label mb-1 w-100">Details&nbsp;</Label>
                <Input
                  className="px-3 pt-1"
                  style={{
                    width: "320px",
                    height: "32px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                  onChange={(e) => {
                    setDetails(e.target.value);
                  }}
                  value={details}
                  placeholder={"Enter Details"}
                  name="details"
                  type="text"
                />
              </div>
              <div className="mt-3">
                <Label className="label mb-1 w-100">Template File&nbsp;</Label>
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="px-3 text-center d-flex align-items-center justify-content-center"
                    style={{
                      width: "320px",
                      height: "32px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      backgroundColor: "#F8F8F8",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                      cursor: "pointer",
                    }}
                    onClick={handleFilePick} // On click, trigger the file picker
                  >
                    {templateName ? (
                      <DocumentItem
                        doc={templateName}
                        setFiles={(e) => {
                          e.stopPropagation();
                          setTemplateName();
                        }}
                      />
                    ) : fileLoading ? (
                      <BiLoaderCircle />
                    ) : (
                      <div className="d-flex gap-2 align-items-center justify-content-center">
                        <FaUpload color={"gray"} />
                        <div style={{ fontSize: "13px" }}> Upload File</div>
                      </div>
                    )}
                  </div>
                  {templateName && documentViewerData && (
                    <button
                      type="button"
                      className="btn btn-link p-0 text-secondary hover-dark cursor-pointer me-1"
                      onClick={() => showDocumentFile(workFlowData?.documentId)}
                    >
                      <img
                        role="button"
                        width={21}
                        height={21}
                        src={ViewLogo}
                        alt="UploadIcon"
                        title="View Template"
                      />
                    </button>
                  )}

                  {documentViewerData &&
                    [...wordExt, ...excelExt].includes(
                      documentViewerData?.filename?.split(".").pop(),
                    ) && (
                      <>
                        <img
                          className={`cursor-pointer ${
                            isDocLoading
                              ? "opacity-50 cursor-not-allowed"
                              : "hover:opacity-80"
                          } ${documentViewerData?.inEditMode && "mt-1"}`}
                          width={17}
                          height={17}
                          src={
                            documentViewerData?.inEditMode ? SaveIcon : EditIcon
                          }
                          onClick={() => {
                            if (isDocLoading) return; // prevent click if loading
                            setIsDocLoading(true);
                            const action = documentViewerData?.inEditMode
                              ? saveDocuemntEdit
                              : getDocumentEditorData;
                            action(workFlowData?.documentId).finally(() =>
                              setIsDocLoading(false),
                            );
                          }}
                          title={
                            documentViewerData?.inEditMode
                              ? "Save Template"
                              : "Edit Template"
                          }
                          alt="Edit Icon"
                        />
                      </>
                    )}
                  <input
                    type="file"
                    ref={fileInputRef} // Reference for the hidden input
                    style={{ display: "none" }} // Hide the input
                    onChange={handleFileChange} // Handle file selection
                    accept=".doc,.docx,.pdf, .xls, .xlsx" // Customize allowed file types if needed
                  />
                </div>
              </div>
              {showDocument && (
                <DocumentViewer
                  data={[documentViewerData]}
                  hideToolbar={true}
                  onClose={() => {
                    setShowDocument(false);
                  }}
                />
              )}
              <div className="mt-3">
                <div className="d-flex align-items-center mb-1">
                  <Label className="label  me-2">Output File Name</Label>
                  <Tooltip anchorElement="target" position="top" parentTitle>
                    <FaInfoCircle
                      size={14}
                      color="#6c757d"
                      className="cursor-pointer"
                      title="Use Filename extension .pdf to generate PDF file OR .docx to generate Word file"
                    />
                  </Tooltip>
                </div>
                <Input
                  className="px-3 pt-1"
                  style={{
                    width: "320px",
                    height: "32px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                  placeholder={"File Name"}
                  name="resultFileName"
                  required
                  onChange={(e) => {
                    setFileName(e.target.value);
                  }}
                  value={resultFileName}
                  type="text"
                />
              </div>
            </div>
          )}
        </div>
        <div className="dialog-footer">
          <button className="common-btn me-4">{`${props?.isEdit ? "Update" : "Add"}`}</button>
        </div>
      </form>
    </Dialog>
  );
};

export default AddEditDocTemplate;
